import React, { createContext, useContext } from 'react';

interface BookingVenue {
  id: string;
  name: string;
  slug: string;
  minGroupSize: number;
  images: {
    url: string;
  }[];
  address?: {
    streetAddress1: string;
    streetAddress2: string;
    city: string;
    state: string;
  };
  priceCategory: string;
}

interface BookingSpace {
  id: string;
  name: string;
  slug: string;
  seated?: number;
  standing?: number;
  images: {
    url: string;
  }[];
}

interface BookingContextType {
  venue: BookingVenue;
  space: BookingSpace;
  maxGroupSize: number;
  minGroupSize: number;
}

export const BookingContext = createContext<BookingContextType>({
  venue: {
    id: '',
    name: '',
    slug: '',
    minGroupSize: 0,
    images: [],
    priceCategory: '',
  },
  space: {
    id: '',
    name: '',
    slug: '',
    images: [],
  },
  maxGroupSize: 0,
  minGroupSize: 0,
});

export const useBooking = () => {
  return useContext(BookingContext);
};

export const BookingProvider = ({
  children,
  venue,
  space,
}: {
  children: React.ReactNode;
  venue: BookingVenue;
  space: BookingSpace;
}) => {
  const getMaxGroupSize = () => {
    const seated = space.seated || 0;
    const standing = space.standing || 0;
    return Math.max(seated, standing);
  };

  const maxGroupSize = getMaxGroupSize();
  const minGroupSize =
    venue.minGroupSize >= maxGroupSize ? 1 : venue.minGroupSize;

  return (
    <BookingContext.Provider
      value={{ venue, space, maxGroupSize, minGroupSize }}
    >
      {children}
    </BookingContext.Provider>
  );
};
